// -----------------------------------------------------------------------
// <copyright file="renew-password.component.ts" company="AntemetA">
//     Copyright (c) AntemetA. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';

import { IAuroraState } from 'src/app/_apps/aurora.state';
import { AuthLoginStoreActions } from 'src/app/_apps/auth/store';
import { PasswordResetData } from 'src/app/_apps/auth/api/models/reset-pswd';
import { matchingInputsValidator } from 'src/app/_common/validators/matching-inputs.validator';

@Component({
    selector: 'aa-renew-password',
    templateUrl: './renew-password.component.html',
    styleUrls: [
        './renew-password.component.scss'
    ],
    standalone: false
})
export class RenewPasswordComponent implements OnInit
{
    form: UntypedFormGroup;
    email: () => {};
    code: () => {};
    password: () => {};
    confirmPassword: () => {};

    constructor(
        private formBuilder: UntypedFormBuilder,
        private store: Store<IAuroraState>
    ) { }

    ngOnInit ()
    {
        this.createForm();

        this.email = (): string => this.form.get('email').value;
        this.code = (): string => this.form.get('code').value.trim().toString(10).padStart(6, '0');
        this.password = (): string => this.form.get('password').value;
        this.confirmPassword = (): string => this.form.get('confirmPassword').value;
    }

    onSubmit = () =>
    {
        if (this.form.invalid)
        {
            for (const control in this.form.controls)
            {
                this.form.controls[control].markAsDirty();
            }

            return;
        }

        this.store.dispatch(AuthLoginStoreActions.AuthPasswordReset({
            passwordResetData: {
                email: this.email(),
                code: this.code(),
                newPassword: this.password(),
                newPasswordConfirmed: this.confirmPassword()
            } as PasswordResetData
        }));
    }

    private createForm ()
    {
        this.form = this.formBuilder.group(
            {
                email: ['', [Validators.required]],
                code: ['', [Validators.required]],
                password: ['', [Validators.required, Validators.minLength(4)]],
                confirmPassword: ['', [Validators.required]]
            },
            {
                validator: matchingInputsValidator('password', 'confirmPassword', 'missmatch')
            }
        );
    }
}
